import * as yup from 'yup';

export const CreateDepartamentFormValidation = yup.object().shape({
    description: yup.string().required('Nome do departamento é obrigatório'),
    idFaculty: yup.string().required('Unidade orgânica é obrigatória'),
    province: yup.string().required('Unidade orgânica é obrigatória')
});